export default [
  {
    father: 'Dashboard',
    key: 'dashboard',
    isShow: 0,
    icon: 'desktop',
    children: [
      {
        value: 'Common.KANBAN',
        key: 'kanban',
        link: '/dashboard/kanbanconfig/kanban',
        isShow: 0,
      }
    ]
  },
  {
    father: 'Common.BasicData',
    key: 'basedata',
    isShow: 0,
    icon: 'database',
    children: [
      {
        value: 'Common.AreaBuilding',
        key: 'areabuilding',
        link: '/basedata/areabuilding',
        isShow: 0,

      },
      {
        value: 'Common.MaterialList',
        key: 'materiallist',
        link: '/basedata/materiallist',
        isShow: 0,
      },
      {
        value: 'Common.VendorInfo',
        key: 'vendorinfo',
        link: '/basedata/vendorinfo',
        isShow: 0,
      }
    ]
  },
  {
    father: 'Common.EngineeringApplication',
    key: 'engineeringapplication',
    isShow: 0,
    icon: 'solution',
    children: [
      {
        value: 'Common.DocApplication',
        key: 'invoicesappliction',
        link: '/engineeringapplication/invoicesappliction',
        isShow: 0,
      },
      {
        value: 'Common.MyDoc',
        key: 'myappliction',
        link: '/engineeringapplication/myapplictionconfig/myappliction',
        isShow: 0,
      }
    ]
  },
  {
    father: 'Common.DocApproval',
    key: 'invoicessigned',
    isShow: 0,
    icon: 'usergroup-add',
    children: [
      {
        value: 'Common.ApplyingUnit',
        key: 'unitsigned',
        link: '/invoicessigned/unitsignedconfig/unitsigned',
        isShow: 0,
      },
      {
        value: 'Common.FacilityApproval',
        key: 'factorysigned',
        link: '/invoicessigned/factorysignedconfig/factorysigned',
        isShow: 0,
      }
    ]
  },
  {
    father: 'Common.VendorAppointmentAndBudget',
    key: 'approximateamount',
    isShow: 0,
    icon: 'whats-app',
    children: [
      {
        value: 'Common.VendorAppointment',
        key: 'appointmanufacturer',
        link: '/approximateamount/appointmanufacturerconfig/appointmanufacturer',
        isShow: 0,
      },
      {
        value: 'Common.Budgeting',
        key: 'budgetestimates',
        link: '/approximateamount/budgetestimatesconfig/budgetestimates',
        isShow: 0,
      },
      // {
      //   value: '厂商工程管理评鉴',
      //   key: 'evaluation',
      //   link: '/approximateamount/evaluationconfig/evaluation',
      //   isShow: 0,
      // }
    ]
  },
  {
    father: 'Common.VendorBid',
    key: 'manufacturerbid',
    isShow: 0,
    icon: 'profile',
    children: [
      {
        value: 'Common.BidCreating',
        key: 'manufacturerbid',
        link: '/manufacturerbid/manufacturerbidconfig/makemanufacturerbid',
        isShow: 0,
      }
    ]
  },
  {
    father: 'Common.Inquiry',
    key: 'inquiry',
    isShow: 0,
    icon: 'pay-circle',
    children: [
      {
        value: 'Common.FacAssInquiry',
        key: 'factoryinquiry',
        link: '/inquiry/factoryinquiryconfig/factoryinquiry',
        isShow: 0,
      }
    ]
  },
  {
    father: 'Common.REPORT',
    key: 'report',
    isShow: 0,
    icon: 'area-chart',
    children: [
      {
        value: 'Common.EngineeringDetails',
        key: 'projectdetails',
        link: '/report/projectdetailsconfig/projectdetails',
        isShow: 0,
      },
      {
        value: 'Common.DocStatusTable',
        key: 'formstatusprogress',
        link: '/report/formstatusprogressconfig/formstatusprogress',
        isShow: 0,
      }
    ]
  }
]
